import { matchesSprintFilter } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/dependencies/index.tsx';
import type { Issue } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/domain/issues/types.tsx';
import type { IssueLinkType } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/domain/system/types.tsx';
import type { Filters } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/ui/main/tabs/dependencies/filters/types.tsx';
import { isDefined } from '@atlassian/jira-portfolio-3-portfolio/src/common/ramda/index.tsx';
import { ISSUE_LINK_DIRECTION } from '@atlassian/jira-portfolio-3-portfolio/src/common/view/constant.tsx';
import type { TypeOption } from './types.tsx';

export const handleLinkTypes = (issueLinkTypes: IssueLinkType[]) =>
	issueLinkTypes.reduce((acc: TypeOption[], { id, inward, outward }) => {
		// if the inward and out ward has the same label, we always just put inward direction link type
		// which aligned with Jira
		if (inward === outward) {
			acc.push({
				value: `${id}_${ISSUE_LINK_DIRECTION.INWARD}`,
				label: inward,
				direction: ISSUE_LINK_DIRECTION.INWARD,
				id: `${id}`,
				selected: acc.length === 0,
			});
		} else {
			Object.entries({ outward, inward }).forEach(([direction, label]) => {
				acc.push({
					value: `${id}_${direction}`,
					label,
					direction,
					id: `${id}`,
					selected: acc.length === 0,
				});
			});
		}
		return acc;
	}, []);

export const isFilteredOut = (
	{ issueFilter, projectFilter, sprintFilter }: Filters,
	filteredIssues: Issue[] = [],
	issue: Issue,
) => {
	const { id, project } = issue;

	if (
		isDefined(issueFilter) &&
		issueFilter !== id &&
		!filteredIssues.some(({ id: issueId }) => issueId === id)
	) {
		return true;
	}

	if (isDefined(projectFilter) && !projectFilter.map((p) => String(p)).includes(String(project))) {
		return true;
	}
	if (isDefined(sprintFilter)) {
		const filterSprints = new Set(sprintFilter);
		return !matchesSprintFilter(issue, filterSprints);
	}

	return false;
};

export const isSourceAndTargetFilteredOut = (
	dependencyFilters: Filters,
	filteredIssues: Issue[],
	[target, source]: Issue[],
) => {
	// Only check filters if both source and target are selected because only one of them need to match the filters
	if (dependencyFilters && target && source) {
		return (
			isFilteredOut(dependencyFilters, filteredIssues, source) &&
			isFilteredOut(dependencyFilters, filteredIssues, target)
		);
	}
	return false;
};
